<template>
  <div>
    <img class="other-banner" src="../assets/imgs/news-banner.png"/>
    <img class="img-title mobile" src="../assets/mobile-imgs/news-title.png"/>
    <ul class="wrap">
      <li v-for="item in arr" :key="item">
        <img alt="" :src="item.img"/>
        <div>
          <p class="title">{{ item.time }}</p>
          <div class="hr"></div>
          <p class="content">
            {{ $overflow(item.str, 4) }}
          </p>
          <p class="date">{{ item.time }}</p>
        </div>
      </li>
    </ul>
    <el-pagination
        :total="1000"
        class="pc"
        layout="prev, pager, next"
        next-text="下一页"
        prev-text="上一页"
    >
    </el-pagination>
    <p class="more mobile">点击加载下一页</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      arr: [{
        img:require('../assets/imgs/news/1.png'),
        time: "2022年1月",
        str: '2021年12月21日至22日四川省智能终端产业发展交流暨联盟会员大会在宣宾召开，为积极推动四川省智能终端产业发展，推进校企合作新举措；为我省智能终端产业生态圈建设提供新思路，创新产业链协同与配套合作模式；为进一步推动我省电子信息产业高质量转型，发展大会正式成立了“四川省智能终端产业联盟教育专委会暨四川产教融合人才实训基地”。',
      }, {
        img:require('../assets/imgs/news/2.png'),
        time: "2022年1月",
        str: '十九大报告提出”加强社会心理服务体系建设、培育自尊自信、理性平和、积极向上的社会心态“的社会要求。2018年底国家卫健委和中央政法委等10部委联合发布的《关于印发全国社会心理服务体系建设的通知》，全国社会心理服务体系建设三年试点即将结束并进入全面推广建设新阶段。'
      }, {
        img:require('../assets/imgs/news/3.png'),
        time: "2022年1月",
        str: '2021年8月5日，记者从司法厅获悉，日前司法厅召开全省智慧矫正中心创建工作启动会，安排部署全省智慧矫正中心创建工作。会议强调，要按照司法部关于“数字法治智慧司法的部署要求，将互联网，云计算、物联网、大数据、人工智能、区块链等现代信息技术与社区矫正工作深度融合。'
      }, {
        img:require('../assets/imgs/news/4.png'),
        time: "2021年12月",
        str: '11月29日，教育部召开了全国高校学生心理健康教育工作推进会，部署推动高校学生心理健康教育工作高质量发展。教育部党组书记、部长怀进鹏出席会议讲话，教育部党组成员、副部长翁铁慧出席并宣读新一届高校学生心理健康教育专家指导委员会委员名单。'
      }, {
        img:require('../assets/imgs/news/5.png'),
        time: "2021年10月",
        str: '教育部日前对政协《关于进一步落实青少年抑郁症防治措施的提案》的答复中明确，将抑郁症筛查纳入学生健康体检内容，建立学生心理健康档案，多渠道推进青少年抑郁症防治工作。\n' +
            '辰微沐阳心理积极响应国家政策，辰微智慧心理系统已服务10万+学生心理体检，助力300多所学校搭建心理档案系统。'
      }, {
        img:require('../assets/imgs/news/6.png'),
        time: "2021年10月",
        str: '10月10日为世界精神卫生日，今年的主题为：【青春之心灵、青春之少年】。旨在帮助儿童青少年掌握心理健康相关知识，提升心理调适能力；协助家长树立科学的教育理念，帮助孩子正确认识，处理碰到的情绪问题。'
      }],
    };
  },
  created() {
  }
};
</script>

<style lang="less" scoped>
li {
  width: 100%;
  display: flex;
  margin-bottom: 50px;

  img {
    width: 450px;
    height: 225px;
  }

  div {
    width: calc(100% - 225px);
    padding-left: 28px;
    box-sizing: border-box;
    padding-top: 5px;

    .title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #42aab2;
      overflow: hidden;
    }

    .hr {
      width: 36px;
      height: 5px;
      background: #42aab2;
      margin: 18px 0;
    }

    .content {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #696969;
      line-height: 30px;
      margin-bottom: 34px;
    }

    .date {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #9f9e9e;
    }
  }
}

@media (max-width: 760px) {
  .img-title {
    height: 0.42rem;
    display: block;
    margin: 0.3rem auto;
  }

  ul {
    li {
      margin-bottom: 0.3rem;

      img {
        width: 2.9rem;
        height: 2.2rem;
      }

      div {
        padding-left: 0.25rem;
        width: calc(100% - 3.15rem);

        .title {
          font-size: 0.2rem;
        }

        .hr {
          margin-top: 0.17rem;
          margin-bottom: 0.24rem;
          height: 2px;
          width: 0.36rem;
        }

        .content {
          font-size: 0.2rem;
          line-height: 0.3rem;
          margin-bottom: 0.3rem;
        }

        .date {
          font-size: 0.14rem;
        }
      }
    }
  }
}
</style>
